import instObj from '@/backend/axios-instances'

const resource = "/cladify/rfq"
const instance = instObj.baseInstance

export default {
  get(rfqId, parameters) {
    return instance.get(`${resource}/${rfqId}`, { params: parameters });
  },
  put(rfqId, data, parameters) {
    return instance.put(`${resource}/${rfqId}`, data, { params: parameters });
  },
  delete(rfqId) {
    return instance.delete(`${resource}/${rfqId}`);
  },
  addAttachment(rfqId, data) {
    return instance.post(`${resource}/${rfqId}/attachment`, data);
  },
  duplicate(rfqId, data) {
    return instance.post(`${resource}/${rfqId}/duplicate`, data);
  },
  generateToken(rfqId, data) {
    return instance.put(`${resource}/${rfqId}/token`, data);
  },
  blacklistToken(rfqId) {
    return instance.put(`${resource}/${rfqId}/token/blacklist`);
  }
}
